import { TooltipDesktop } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AgencyIcons.css';
import { HONEST_LEVEl_ICON } from './constants';
import { WorkHonestlyTooltip } from '../../WorkHonestlyTooltip';

interface IAgencyIconsProps {
  levelOrder: number;
  levelName: string;
}

const AgencyIconsComponent: React.FC<React.PropsWithChildren<IAgencyIconsProps>> = ({ levelOrder, levelName }) => {
  const icon = HONEST_LEVEl_ICON[levelOrder];

  return (
    <TooltipDesktop
      title={<WorkHonestlyTooltip levelNumber={levelOrder} levelName={levelName} />}
      theme="white"
      placement="top"
    >
      <img data-testid={`AgencyIconsLevel_${levelOrder}`} src={icon} className={styles['honest-icon']} />
    </TooltipDesktop>
  );
};

export const AgencyIcons = React.memo(AgencyIconsComponent);
